module.exports = __webpack_public_path__ + "img/explain.f2d925f1.png";